import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from 'store'
import { actions as reportingBenchmarkActions } from 'store/reporting/benchmark'
import BenchmarkReport from 'containers/dashboard/benchmarkReport/BenchmarkReport'
import BenchmarkReportGenerator from 'containers/benchmark/benchmarkReportGenerator/BenchmarkReportGenerator'
import { useBenchmarkExists } from 'containers/dashboard/benchmarkReport/hooks/useBenchmarkExists'

type Props = {
  id: string
  name: string
  ipcrCodes: string[]
  companyNames: string[]
}

export default function BenchmarkReportForMultisector({ id, name, ipcrCodes, companyNames }: Props) {
  const dispatch = useAppDispatch()
  const { exists } = useBenchmarkExists(id)
  const [mode, setMode] = useState<'view' | 'generate'>(exists ? 'view' : 'generate')
  const benchmarkId = useSelector((state: RootState) => state.reportingBenchmark.benchmarkId)

  useEffect(() => {
    if (exists) {
      setMode('view')
    }
  }, [exists, dispatch])

  useEffect(() => {
    if (!benchmarkId) {
      dispatch(reportingBenchmarkActions.fetchBenchmarkStatus(id))
    }
  }, [id, benchmarkId, dispatch])

  if (mode === 'generate') {
    return (
      <BenchmarkReportGenerator
        id={id}
        name={name}
        ipcrCodes={ipcrCodes}
        origin="multisector"
        companyNames={companyNames}
        onCreated={() => setMode('view')}
        isRegeneration={Boolean(exists)}
      />
    )
  }

  return <BenchmarkReport id={id} onRegenerate={() => setMode('generate')} />
}
